function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM, { unmountComponentAtNode } from 'react-dom';
import { StateHandler, controllerMixin, ThemeProvider } from 'oskari-ui/util';
import { showAlertPopup } from '../view/AlertPopup';
import { LayerSwipe, SPLITTER_WIDTH } from '../view/LayerSwipe';
import { getRenderPixel } from 'ol/render';
import { unByKey } from 'ol/Observable';
var Alerts = {
  NO_RASTER: 'noRaster',
  NOT_VISIBLE: 'notVisible'
};
var UIHandler = /*#__PURE__*/function (_StateHandler) {
  function UIHandler(instance) {
    var _this;
    _classCallCheck(this, UIHandler);
    _this = _callSuper(this, UIHandler);
    _this.instance = instance;
    var mapSize = _this.getMapSize();
    var _ref = instance.conf || {},
      _ref$noUI = _ref.noUI,
      noUI = _ref$noUI === void 0 ? false : _ref$noUI;
    _this.setState({
      active: false,
      layerId: null,
      position: (mapSize.width - SPLITTER_WIDTH) / 2,
      mapSize: mapSize,
      noUI: noUI
    });
    _this.alertPopupControls = null;
    _this.element = null;
    _this.eventListenerKeys = [];
    _this.addStateListener(function () {
      return _this.render();
    });
    return _this;
  }
  _inherits(UIHandler, _StateHandler);
  return _createClass(UIHandler, [{
    key: "getMapSize",
    value: function getMapSize() {
      return this.instance.getMapModule().getSize();
    }
  }, {
    key: "initTopmostLayer",
    value: function initTopmostLayer() {
      var _this$getState = this.getState(),
        current = _this$getState.layerId;
      var sb = this.instance.getSandbox();
      var layer = sb.findAllSelectedMapLayers().findLast(function (l) {
        return l.isVisible();
      });
      var layerId = layer === null || layer === void 0 ? void 0 : layer.getId();
      if (layerId && current === layerId) {
        // no need to update
        return;
      }
      this.unregisterEventListeners();
      if (!layerId) {
        this.showAlert(Alerts.NO_RASTER);
      }
      var olLayers = this.instance.getMapModule().getOLMapLayers(layerId) || [];
      this.registerEventListeners(olLayers);
      this.checkVisibility(layer);
      this.updateState({
        layerId: layerId
      });
    }
  }, {
    key: "checkVisibility",
    value: function checkVisibility(layer) {
      var _this2 = this;
      if (!layer) {
        return;
      }
      var _layer$getVisibilityI = layer.getVisibilityInfo(),
        inScale = _layer$getVisibilityI.inScale,
        geometryMatch = _layer$getVisibilityI.geometryMatch,
        unsupported = _layer$getVisibilityI.unsupported;
      if (unsupported) {
        var message = unsupported.getDescription() + ' ' + unsupported.getActionText();
        var action = unsupported.getAction();
        this.showAlert(Alerts.NOT_VISIBLE, action, message);
      }
      if (!inScale || !geometryMatch) {
        var zoomToExtent = !geometryMatch;
        var _action = function _action() {
          return _this2.instance.getSandbox().postRequestByName('MapModulePlugin.MapMoveByLayerContentRequest', [layer.getId(), zoomToExtent]);
        };
        this.showAlert(Alerts.NOT_VISIBLE, _action);
      }
    }
  }, {
    key: "onMapLayerEvent",
    value: function onMapLayerEvent() {
      if (this.getState().active) {
        this.initTopmostLayer();
      }
    }
  }, {
    key: "onMapSizeChange",
    value: function onMapSizeChange() {
      var _this$getState2 = this.getState(),
        active = _this$getState2.active,
        position = _this$getState2.position;
      if (!active) {
        return;
      }
      var mapSize = this.getMapSize();
      var max = mapSize.width - SPLITTER_WIDTH;
      if (position < max) {
        this.updateState({
          mapSize: mapSize
        });
        return;
      }
      this.updateState({
        mapSize: mapSize,
        position: max
      });
    }
  }, {
    key: "setActive",
    value: function setActive(active) {
      var _this$instance$getSan;
      if (this.getState().active === active) {
        return;
      }
      var _this$getState3 = this.getState(),
        layerId = _this$getState3.layerId;
      var mapModule = this.instance.getMapModule();
      var root = mapModule.getMapDOMEl();
      if (active) {
        if (!this.element) {
          this.element = document.createElement('div');
          this.element.classList.add('oskari-react-splitter-container');
          root.appendChild(this.element);
        }
        this.initTopmostLayer();
      } else if (!active && this.element) {
        unmountComponentAtNode(this.element);
        root.removeChild(this.element);
        this.element = null;
        layerId = null;
      }
      mapModule.getMap().render();
      (_this$instance$getSan = this.instance.getSandbox().getService('Oskari.mapframework.service.VectorFeatureService')) === null || _this$instance$getSan === void 0 || _this$instance$getSan.setHoverEnabled(!active);
      this.updateState({
        active: active,
        layerId: layerId
      });
    }
  }, {
    key: "toggleTool",
    value: function toggleTool() {
      var _this$getState4 = this.getState(),
        active = _this$getState4.active;
      this.setActive(!active);
    }
  }, {
    key: "setHideUI",
    value: function setHideUI(noUI) {
      this.updateState({
        noUI: noUI
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.element) {
        return;
      }
      ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(LayerSwipe, _extends({}, this.getState(), {
        controller: this.getController(),
        isMobile: !Oskari.util.mouseExists()
      }))), this.element);
    }
  }, {
    key: "resetPosition",
    value: function resetPosition() {
      var _this$getMapSize = this.getMapSize(),
        width = _this$getMapSize.width;
      var position = (width - SPLITTER_WIDTH) / 2;
      this.setPosition(position);
    }
  }, {
    key: "setPosition",
    value: function setPosition(position) {
      var _this$getState5 = this.getState(),
        layerId = _this$getState5.layerId;
      this.instance.getMapModule().getMap().render();
      this.instance.getSandbox().postRequestByName('GetInfoPlugin.SwipeStatusRequest', [layerId, position]);
      this.updateState({
        position: position
      });
    }
  }, {
    key: "showAlert",
    value: function showAlert(type, action, message) {
      var _this3 = this;
      if (this.alertPopupControls) {
        this.alertPopupControls.close();
      }
      this.alertPopupControls = showAlertPopup(type, action, message, function () {
        return _this3.closeAlert();
      });
    }
  }, {
    key: "closeAlert",
    value: function closeAlert() {
      if (this.alertPopupControls) {
        this.alertPopupControls.close();
      }
      this.alertPopupControls = null;
    }
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners(olLayers) {
      var _this4 = this;
      olLayers.forEach(function (olLayer) {
        var prerenderKey = olLayer.on('prerender', function (event) {
          var _this4$getState = _this4.getState(),
            active = _this4$getState.active,
            position = _this4$getState.position,
            height = _this4$getState.mapSize.height;
          var ctx = event.context;
          if (!active) {
            ctx.restore();
            return;
          }
          var tl = getRenderPixel(event, [0, 0]);
          var tr = getRenderPixel(event, [position, 0]);
          var bl = getRenderPixel(event, [0, height]);
          var br = getRenderPixel(event, [position, height]);
          ctx.save();
          ctx.beginPath();
          ctx.moveTo(tl[0], tl[1]);
          ctx.lineTo(bl[0], bl[1]);
          ctx.lineTo(br[0], br[1]);
          ctx.lineTo(tr[0], tr[1]);
          ctx.closePath();
          ctx.clip();
        });
        _this4.eventListenerKeys.push(prerenderKey);
        var postrenderKey = olLayer.on('postrender', function (event) {
          event.context.restore();
        });
        _this4.eventListenerKeys.push(postrenderKey);
      });
    }
  }, {
    key: "unregisterEventListeners",
    value: function unregisterEventListeners() {
      this.eventListenerKeys.forEach(function (key) {
        return unByKey(key);
      });
      this.eventListenerKeys = [];
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(UIHandler, ['setActive', 'setPosition', 'toggleTool', 'setHideUI']);
export { wrapped as SwipeHandler };